import { DialogCore } from "../dialog/core.js";
//#region src/core/ui/alert-dialog/core.ts
/** A dialog with alert semantics for urgent messages that require acknowledgement. */
var AlertDialogCore = class extends DialogCore {
	constructor() {
		super("alertdialog");
	}
};
//#endregion
export { AlertDialogCore };

//# sourceMappingURL=core.js.map